<router-outlet></router-outlet>

<!-- app version -->
<div class="app-version" *ngIf="!isProduction">
	v{{ appVersion }} (ng v{{ angularVersion }})
</div>
